/**
 * Created by h3 on 2018-09-28.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {TimelineLite} from "gsap";
import {FruitsGameModuleConfig} from "../../FruitsGameModuleConfig";
import {FruitsSoundConfig} from "../../FruitsSoundConfig";
import {FruitsGameMode} from "../../gamemode/FruitsGameMode";
import {FruitsReels} from "../../reel/reelarea/FruitsReels";
import {FruitsParsedGameData} from "../../server/data/FruitsParsedGameData";

export class FruitsStickyRespinReelStopPresentation extends ReelStopPresentationController {

    private _isNextSticky:boolean;
    private _stickySymbol:string;
    private _isStickyMode:boolean;
    private _stickyPositions:boolean[];
    private _isStickyRespinTriggeredThisSpin:boolean;
    private _isBonusTriggeredThisSpin:boolean;
    private _isNearStickyWin:boolean;
    private _isNearStickyWinPortrait:boolean;
    private _hasWin:boolean;
    private _parsedLastReel:number;
    private _collectedScatters:number = 0;
    private _reelsWithSound:number[];
    private _hasSound:boolean = false;
    // private _allReelsSticky:boolean;

    private _stopCounter = 0;
    private _attentionReel = 3;

    private _timeLine:TimelineLite | null;

    public static readonly RESET:string = "fruitsStickyRespinReelStopPresentation_reset";
    private _orientation:Orientation;

    constructor(index:number) {
        super(index, "FruitsStickyRespinReelStopPresentation");
        EventHandler.addEventListener(this, FruitsReels.SET_ORIENTATION, (event:GameEvent) => this.onOrientationChange(event.params[0]));
    }

    protected parseFeatureGameData(data:FruitsParsedGameData):void {
        this._isStickyMode = data.mode === FruitsGameMode.STICKY_RESPIN;
        this._isNextSticky = data.nextMode === FruitsGameMode.STICKY_RESPIN;
        this._stickySymbol = data.stickySymbol;
        this._stickyPositions = data.overlayStickySymbolsAfterSpin;
        this._isStickyRespinTriggeredThisSpin = data.isStickyRespinTriggeredThisSpin;
        this._isBonusTriggeredThisSpin = data.isBonusTriggeredThisSpin;
        this._hasWin = data.betWins !== null && data.betWins.length > 0;
        this._isNearStickyWin = data.nearWinPositions[1][2];
        this._isNearStickyWinPortrait = data.nearWinPositionsPortrait[1][1];
        this._parsedLastReel = this.parseLastReel(data.overlayStickySymbolsBeforeSpin);
        this._collectedScatters = data.collectedScatterAfter;
        this._reelsWithSound = this.evaluateReelSound(this._stickyPositions);

        this.nullifyTimeline();
        this._stopCounter = 0;

        this._hasSound = false;
    }

    private parseLastReel(stickyBeforeSpin:boolean[]):number {
        for(let i = 15; i > -1; i--) {
            if(!stickyBeforeSpin[i]) {
                return i;
            }
        }
        return 0;
    }

    private evaluateReelSound(stickyPos:boolean[]):number[] {
        const reelsWithSound = [];
        const chunk = 3;

        let reel = [];
        let i:number, j:number, n:number, reelIndex:number;
        for(i = 4, j = stickyPos.length; i < j; i += chunk) {
            reel = stickyPos.slice(i, i + chunk);
            if(this._orientation === Orientation.LANDSCAPE) {
                for(n = 0; n < reel.length; n++) {
                    if(reel[n]) {
                        reelsWithSound.push(i + n);
                    }
                }
            } else {
                for(n = 3; n >= 0; n--) {
                    if(reel[n]) {
                        reelsWithSound.push(i + n);
                        break;
                    }
                }
            }
        }
        return reelsWithSound;
    }

    public onReelBounce(data:IReelStoppedData):void {

        let nearWinSticky:boolean = this._orientation === Orientation.LANDSCAPE ? this._isNearStickyWin : this._isNearStickyWinPortrait;

        let isAttentionReel:boolean = this._orientation === Orientation.LANDSCAPE ? this._attentionReel - 1 === data.reelId : this._attentionReel + 1 === data.reelId;

        if(nearWinSticky && isAttentionReel && this._gameData!.mode === FruitsGameMode.NORMAL) {
            SlotGame.sound.playEffect(FruitsSoundConfig.STICKY_ANTICIPATION);
        }

        let nextSticky:boolean = this._gameData && this._isStickyRespinTriggeredThisSpin ? this._orientation === Orientation.LANDSCAPE ? data.reelId === 3 : data.reelId === 2 : false;

        let landingSticky:boolean = this._gameData!.mode === FruitsGameMode.STICKY_RESPIN && data.reelId > 3 && (<FruitsParsedGameData>this._gameData!).newOverlayStickySymbols[data.reelId];

        if(nextSticky || landingSticky) {
            SlotGame.sound.playEffect(FruitsSoundConfig.STICKY_REEL_LANDING);
        }

        if(this._stickyPositions[data.reelId] && data.reelId > 3 && this._isStickyMode) {
            this.playBounceSound(data.reelId);
        }
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        this._timeLine = new TimelineLite({});

        let lastReel:boolean = data.reelId === (this._parsedLastReel);
        if(data.reelId === this._attentionReel && this._isStickyRespinTriggeredThisSpin) {
            this._timeLine.add(FruitsGameModuleConfig.stickyRespinView.getStickyAnimation2x2(this._stickySymbol, false));
            this._timeLine.add(() => FruitsGameModuleConfig.stickyRespinView.showRainbow(), .9);
        }

        if(this._stickyPositions[data.reelId] && data.reelId > 3 && this._isStickyMode) {
            let sym:StateReelSymbol | null = Reels.getSymbol(data.reelId, 0);
            let hasSound:boolean = false;
            if(sym && sym.currentState!.keyword !== "respin") {
                if(!this._hasSound) {
                    hasSound = this._reelsWithSound.indexOf(data.reelId) > -1;
                    if(hasSound)
                        this._hasSound = true;
                }

                this._timeLine.add(FruitsGameModuleConfig.stickyRespinOverlayView.getSmallStickySymAnimation(sym!.symName, data.reelId, hasSound));
            }
        }

        if(lastReel && this._isStickyRespinTriggeredThisSpin) {
            if(this._isBonusTriggeredThisSpin) {
                this._timeLine.add(FruitsGameModuleConfig.stickyAndBonusView.getAnimation());
            } else {
                this._timeLine.add([
                    FruitsGameModuleConfig.stickyRespinView.getStickyAnimationScreen(),
                ]);
            }
        }

        if(lastReel) {
            if(this._gameData!.mode !== FruitsGameMode.BONUS_GAME) {
                if(this._isNextSticky) {
                    this._timeLine.add(() => FruitsGameModuleConfig.stickyRespinView.stopRainbowLoop());
                } else {
                    this._timeLine.add(FruitsGameModuleConfig.stickyRespinView.endBigStickyAnimation(this._stickySymbol, this._gameData!.nextMode));
                    if(this._gameData && this._gameData!.mode === FruitsGameMode.STICKY_RESPIN)
                        this.playNoWinSound();
                }
            }
        }
        this._timeLine.add(() => this.dispatchCompleteEvent(data.reelId));
        this._stopCounter++;
    }

    private playBounceSound(reelId:number):void {

        switch(reelId) {
            case 4:
            case 5:
            case 6:
                SlotGame.sound.playEffect(FruitsSoundConfig.WIN_ATTENTION1);
                break;
            case 7:
            case 8:
            case 9:
                SlotGame.sound.playEffect(FruitsSoundConfig.WIN_ATTENTION2);
                break;
            case 10:
            case 11:
            case 12:
                SlotGame.sound.playEffect(FruitsSoundConfig.WIN_ATTENTION3);
                break;
            case 13:
            case 14:
            case 15:
                SlotGame.sound.playEffect(FruitsSoundConfig.WIN_ATTENTION4);
                break;

            default:
                break;
        }


    }

    protected resetFeature():void {
        if(!this._isNextSticky) {
            FruitsGameModuleConfig.stickyRespinOverlayView.initiateVisualObjects();
        }
    }

    private playNoWinSound():void {
        SlotGame.sound.playEffect(FruitsSoundConfig.STICKY_ENDS);
        if(!this._hasWin) {
            SlotGame.sound.playEffect(FruitsSoundConfig.STICKY_NO_WIN);
        }
    }

    private nullifyTimeline():void {
        if(this._timeLine) {
            this._timeLine.totalProgress(1);
            this._timeLine.pause();
            this._timeLine.clear();
            this._timeLine.kill();
            this._timeLine = null;
        }
    }

    private onOrientationChange(orientation:Orientation) {
        this._orientation = orientation;
        this._attentionReel = this._orientation === Orientation.LANDSCAPE ? 3 : 2;
        this.nullifyTimeline();
    }
}